import React from "react";

export default function HomePage() {
  return <h2>HomePage</h2>;
}
